import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { VentanaFlotante } from '../models/VentanaFlotante';
import { GlassTalleresService } from '../services/glass-talleres.service';

@Component({
  selector: 'ral-busqueda-siniestros-gt',
  templateUrl: './busqueda-siniestros.component.html',
  styleUrls: ['./busqueda-siniestros.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class BusquedaSiniestrosGtComponent extends VentanaFlotante implements AfterViewInit {
  /** true = seleccionar siniestro (tab Incidencia); false = consulta con detalle (tab Siniestro) */
  modoSeleccion = false;
  listadoResultados: any[] = [];
  dataColumns = [
    'otralarsa',
    'telefono',
    'nombre',
    'matricula',
    'compania',
    'estado',
    'fecha_cita',
    'codpos',
    'danos',
    'expediente',
    'canal_entrada',
    'gt_taller',
  ];
  displayedColumns: string[] = [];
  columnLabels: { [key: string]: string } = {
    otralarsa: 'ID Ralarsa',
    telefono: 'Teléfono',
    nombre: 'Nombre',
    matricula: 'Matrícula',
    compania: 'Compañía',
    estado: 'Estado',
    fecha_cita: 'Fecha cita',
    codpos: 'Código postal',
    danos: 'Daños',
    expediente: 'Expediente',
    canal_entrada: 'Canal entrada',
    gt_taller: 'Gt taller',
    accion: '',
  };
  displayedColumnsIncidencia = ['id', 'idRalarsa', 'estado', 'incidencia'];
  columnLabelsIncidencia: { [key: string]: string } = {
    id: 'Id',
    idRalarsa: 'Id Ralarsa',
    estado: 'Estado',
    incidencia: 'Incidencia',
  };
  dataSource: MatTableDataSource<any> = new MatTableDataSource(this.listadoResultados);
  @ViewChild(MatPaginator) paginator: MatPaginator | null = null;

  expandedElement: any = null;
  detailData: { [key: string]: any[] } = {};
  cargandoDetalle = false;
  private token = '';

  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: any | null,
    private glassTalleresService: GlassTalleresService,
  ) {
    super(dialogRef, data);
  }

  ngOnInit(): void {
    this.listadoResultados = this.data?.listado || [];
    this.token = this.data?.token || '';
    this.modoSeleccion = !!this.data?.modoSeleccion;
    this.displayedColumns = this.modoSeleccion
      ? ['accion', ...this.dataColumns]
      : ['arrow', ...this.dataColumns];
    this.dataSource.data = this.listadoResultados;
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  getRowKey(element: any): string {
    return String(element?.otralarsa ?? element?.id_ralarsa ?? '').trim();
  }

  toggleRow(element: any, event?: Event): void {
    if (this.modoSeleccion) {
      return;
    }
    event?.stopPropagation();
    if (this.expandedElement === element) {
      this.expandedElement = null;
      return;
    }
    this.expandedElement = element;
    this.cargarIncidencias(element);
  }

  private async cargarIncidencias(element: any): Promise<void> {
    const key = this.getRowKey(element);
    if (!key) {
      this.detailData[key] = [];
      return;
    }
    if (this.detailData[key]) {
      return;
    }

    try {
      this.cargandoDetalle = true;
      const res = await this.glassTalleresService.buscarIncidencias(this.token, key);
      const listado = Array.isArray(res)
        ? res
        : (res?.data || res?.Data || []);
      this.detailData[key] = (Array.isArray(listado) ? listado : []).map((item: any) => ({
        id: item.id ?? item.Id ?? '',
        idRalarsa: item.idRalarsa ?? item.IdRalarsa ?? item.id_ralarsa ?? item.Id_ralarsa ?? key,
        estado: item.estado ?? item.Estado ?? '',
        incidencia: item.incidencia ?? item.Incidencia ?? '',
      }));
    } catch {
      this.detailData[key] = [];
    } finally {
      this.cargandoDetalle = false;
    }
  }

  seleccionarSiniestro(element: any, event?: Event): void {
    event?.stopPropagation();
    this.dialogRef.close(element);
  }

  /** Click en fila: selecciona el siniestro (Siniestro e Incidencia) */
  onFilaClick(element: any, event?: Event): void {
    event?.stopPropagation();
    this.dialogRef.close(element);
  }

  volcarSeleccion(seleccion: any): void {
    if (this.modoSeleccion) {
      return;
    }
    this.dialogRef.close(seleccion);
  }

  onPageChange(event: any): void {
    if (this.paginator) {
      this.paginator.pageIndex = event.pageIndex;
    }
  }
}
